import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetBOUserRolesRPC } from "./getBoUserRolesRPC";

export class GetBOUserRolesRPCClientImpl extends GetBOUserRolesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetBOUserRolesRPC.Request): Promise<LeoRPCResult<GetBOUserRolesRPC.Response, GetBOUserRolesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "bo-user-management/GetBOUserRoles",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetBOUserRolesRPC.ResponseDTO,
      GetBOUserRolesRPC.Errors.ErrorsDTO,
      GetBOUserRolesRPC.Response,
      GetBOUserRolesRPC.Errors.Errors
    >(
      response,
      "bo-user-management/GetBOUserRoles",
      GetBOUserRolesRPC.Response.fromDTO,
      GetBOUserRolesRPC.Errors.fromDTO
    );
  }
}
